import React from "react";
import { usePage } from "@inertiajs/react";
import useTranslation from "@hooks/use_translation";
import TaskCard from "./TaskCard";
import type { Task } from "@/types/task";

interface TaskCardProps {
  task: Task;
}

const SetupQuickApplyProfile: React.FC<TaskCardProps> = ({ task }) => {
  const { t } = useTranslation("tasks");
  const { uploadResumeModal } = usePage<{ uploadResumeModal?: boolean }>().props;

  let description;
  let actionText;
  if (uploadResumeModal) {
    description = t("quickApply.descriptionUploadResumeModal");
    actionText = t("quickApply.completeProfileUploadResumeModal");
  } else {
    description = t("quickApply.description");
    actionText = t("quickApply.completeProfile");
  }

  return (
    <TaskCard
      task={task}
      title={t("quickApply.title")}
      description={description}
      actionHref="/quick_apply"
      actionText={actionText}
      externalLink={false}
    />
  );
};

export default SetupQuickApplyProfile;
